/**
 * For SSR this should not be a singleton, and should export the app, not a context instance.
 * However, we need access to the shared context within React components that are within a Backbone view.
 * This gives us a way to do that.
 */

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import batchedUpdatePlugin from 'vendor/cnpm/fluxible.v0-4/addons/batchedUpdatePlugin';
import Fluxible from 'vendor/cnpm/fluxible.v0-4/index';

// proctor config
import { store as ProctorConfigStore } from 'bundles/assess-common/reducers/ProctorConfigReducer';
import ClassmatesProfileStore from 'bundles/classmates/stores/ClassmatesProfileStore';
import ItemFeedbackStore from 'bundles/content-feedback/stores/ItemFeedbackStore';
import ProgrammingGradingProblemsStore from 'bundles/content-feedback/stores/ProgrammingGradingProblemsStore';
import CourseReferencesStore from 'bundles/course-home/page-course-references/stores/CourseReferencesStore';
import SessionStore from 'bundles/course-sessions/stores/SessionStore';
import ComputedModelStore from 'bundles/course-v2/stores/ComputedModelStore';
import SessionFilterStore from 'bundles/discussions/stores/SessionFilterStore';
import GroupSettingStore from 'bundles/group-enroll/stores/GroupSettingStore';
import GroupEventsStore from 'bundles/group-events/stores/GroupEventsStore';
import CertificateStore from 'bundles/in-course-stores/stores/CertificateStore';
import ChangeViewSettingsModalStore from 'bundles/in-course-stores/stores/ChangeViewSettingsModalStore';
import CourseMembershipStore from 'bundles/in-course-stores/stores/CourseMembershipStore';
import CourseScheduleStore from 'bundles/in-course-stores/stores/CourseScheduleStore';
import CourseStore from 'bundles/in-course-stores/stores/CourseStore';
import CourseViewGradeStore from 'bundles/in-course-stores/stores/CourseViewGradeStore';
import HonorsUserPreferencesStore from 'bundles/in-course-stores/stores/HonorsUserPreferencesStore';
import MenuStore from 'bundles/in-course-stores/stores/MenuStore';
import ProgressStore from 'bundles/in-course-stores/stores/ProgressStore';
import S12nStore from 'bundles/in-course-stores/stores/S12nStore';
import VerificationStore from 'bundles/in-course-stores/stores/VerificationStore';
import VideoItemStore from 'bundles/item-lecture/stores/VideoItemStore';
import UngradedLabItemStore from 'bundles/item-ungraded-lab/stores/UngradedLabItemStore';
import ModuleLearningObjectivesStore from 'bundles/learner-learning-objectives/stores/ModuleLearningObjectivesStore';
import NaptimeStore from 'bundles/naptimejs/stores/NaptimeStore';
import routesFactory from 'bundles/ondemand/ondemandRoutes';
import PeerAdminStore from 'bundles/peer-admin/stores/PeerAdminStore';
import { store as PeerDisplayablePhaseScheduleStore } from 'bundles/peer/reducers/DisplayablePhaseScheduleReducer';
// Peer review assignments
import { store as PeerAssignmentStore } from 'bundles/peer/reducers/PeerAssignmentReducer';
import { store as PeerPermissionsAndProgressesStore } from 'bundles/peer/reducers/PeerPermissionsAndProgressesReducer';
import { store as PeerReviewQueueStore } from 'bundles/peer/reducers/PeerReviewQueueReducer';
import { store as PeerSubmissionAppStateStore } from 'bundles/peer/reducers/PeerSubmissionAppStateReducer';
import { store as PeerSubmissionDraftStore } from 'bundles/peer/reducers/PeerSubmissionDraftReducer';
import { store as PeerViewSubmissionStore } from 'bundles/peer/reducers/PeerViewSubmissionReducer';
import ProfileStore from 'bundles/profile/stores/ProfileStore';
import ApplicationStore from 'bundles/ssr/stores/ApplicationStore';
import HighlightingUIPanelVisibilityPreferenceStore from 'bundles/video-highlighting/utils/HighlightingUIPanelVisibilityPreferenceStore';
import { store as WidgetManagerStore } from 'bundles/widget/reducers/WidgetManagerReducer';

import 'css!bundles/global-styles/global-element-styles';

function appEnvFactory() {
  const app = new Fluxible({
    component: routesFactory(),
  });

  app.registerStore(ApplicationStore);
  app.registerStore(CertificateStore);
  app.registerStore(ChangeViewSettingsModalStore);
  app.registerStore(ClassmatesProfileStore);
  app.registerStore(ComputedModelStore);
  app.registerStore(CourseMembershipStore);
  app.registerStore(CourseReferencesStore);
  app.registerStore(CourseScheduleStore);
  app.registerStore(CourseStore);
  app.registerStore(CourseViewGradeStore);
  app.registerStore(GroupEventsStore);
  app.registerStore(GroupSettingStore);
  app.registerStore(HighlightingUIPanelVisibilityPreferenceStore);
  app.registerStore(HonorsUserPreferencesStore);
  app.registerStore(ItemFeedbackStore);
  app.registerStore(MenuStore);
  app.registerStore(ModuleLearningObjectivesStore);
  app.registerStore(NaptimeStore);
  app.registerStore(PeerAdminStore);
  app.registerStore(ProfileStore);
  app.registerStore(ProgrammingGradingProblemsStore);
  app.registerStore(ProgressStore);
  app.registerStore(S12nStore);
  app.registerStore(SessionFilterStore);
  app.registerStore(SessionStore);
  app.registerStore(UngradedLabItemStore);
  app.registerStore(VerificationStore);
  app.registerStore(VideoItemStore);
  app.registerStore(WidgetManagerStore);

  // proctor config store
  app.registerStore(ProctorConfigStore);

  // peer review assignments
  app.registerStore(PeerAssignmentStore);
  app.registerStore(PeerDisplayablePhaseScheduleStore);
  app.registerStore(PeerSubmissionDraftStore);
  app.registerStore(PeerReviewQueueStore);
  app.registerStore(PeerSubmissionAppStateStore);
  app.registerStore(PeerPermissionsAndProgressesStore);
  app.registerStore(PeerViewSubmissionStore);

  app.plug(batchedUpdatePlugin());

  return app;
}

export default appEnvFactory;
